export const ADD_STATE_DATA = 'ADD_STATE_DATA';
